import { GOOGLE_MAPS_KEY } from 'app/consts'
import { StyledMapImage } from './styles'

interface GoogleMapProps {
  latitude: number
  longitude: number
  width?: number
  height?: number
}

function GoogleMap({
  latitude,
  longitude,
  width = 1000,
  height = 300,
}: GoogleMapProps) {
  return (
    <StyledMapImage
      src={`https://maps.googleapis.com/maps/api/staticmap?center=${latitude}%2c%20${longitude}&zoom=12&size=${width}x${height}&markers=color:red%7C${latitude},${longitude}&key=${GOOGLE_MAPS_KEY}`}
    />
  )
}

export default GoogleMap
